import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfc861ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pannel flex flex-column p-3" }
const _hoisted_2 = { class: "flex justify-content-between" }
const _hoisted_3 = { class: "flex flex-column" }
const _hoisted_4 = { class: "text-default-gray" }
const _hoisted_5 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-micro text-primary-blue mt-2 cursor-pointer uppercase" }, "ouvrir la fiche", -1))
const _hoisted_7 = { class: "flex mt-3 gap-3 flex-wrap md:flex-nowrap" }
const _hoisted_8 = { class: "flex flex-column w-full md:w-4 left-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-small text-gray-l1 font-bold" }, " Création ", -1))
const _hoisted_10 = { class: "flex app-label-small text-gray-D1 font-bold mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-small text-gray-l1 font-bold mt-2 md:mt-4" }, " Dernière mise à jour ", -1))
const _hoisted_12 = { class: "flex app-label-small text-gray-D1 font-bold mt-2" }
const _hoisted_13 = { class: "flex flex-column gap-4 w-full md:w-8" }
const _hoisted_14 = { class: "flex app-label-small text-gray-l1 font-bold mr-2" }
const _hoisted_15 = { class: "flex app-label-small text-gray-D1 font-bold" }
const _hoisted_16 = { class: "flex mt-3 justify-content-center no-mobile-hide" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-micro text-primary-blue mt-2 cursor-pointer uppercase" }, "ouvrir la fiche", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BuildingImage = _resolveComponent("BuildingImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.mybuilding.project), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getFormattedAdress()), 1)
      ]),
      _createVNode(_component_router_link, {
        to: "/building-informations",
        class: "mobile-hide"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_BuildingImage, {
      image_url: _ctx.mybuilding.image_url,
      class: "mt-3",
      style: {"aspect-ratio":"3/1"}
    }, null, 8, ["image_url"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.creationDate), 1),
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.lastUpdateDate), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
            { label: 'Type de bâtiment', value: _ctx.mybuilding.type },
            { label: 'Etages', value: _ctx.mybuilding.floor || '--' },
            { label: 'Cage d\'escalier', value: '--' },
            { label: 'Superficie', value: _ctx.mybuilding.superficy },
            { label: 'Année de construction', value: _ctx.mybuilding.build_period }
          ], ({ label, value }, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex justify-content-between"
          }, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(label), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(value), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_router_link, { to: "/building-informations" }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ]))
}